<div class="container">
    <h4>Requirement List</h4>
    <!-- List View -->
    <ul>
        <li *ngFor="let req of requisites" class="req-body" (click)="openDetails(req)"><!-- (click)="editRequirement(req)" -->
            <div class="requirement">
                <span>{{ req.item }} <i class="fa-solid fa-circle-info"></i></span>
            </div>
            <app-requirement-detail [requirementDetails]="selectedRequirement" *ngIf="selectedRequirement && selectedRequirement.id == req.id"></app-requirement-detail>

          
        </li>
    </ul>

    <!-- Detail View (Editable) -->
    <div *ngIf="selectedRequirement && status == 'update'">  <!--  -->
      <h3>Edit Requisite</h3>
  
      <label for="item">Requirement:</label>
      <input type="text" [(ngModel)]="selectedRequirement.item">
  
      <label for="description">Description:</label>
      <textarea [(ngModel)]="selectedRequirement.description"></textarea>
  
      <div *ngFor="let step of selectedRequirement.steps; let i = index">
        <h4>Step {{ i + 1 }}:</h4>
  
        <label for="step">Step Name:</label>
        <input type="text" [(ngModel)]="step.step">
  
        <label for="description">Description:</label>
        <textarea [(ngModel)]="step.description"></textarea>
  
        <label for="document">Document:</label>
        <input type="text" [(ngModel)]="step.document">
  
        <label for="progress">Progress:</label>
        <input type="text" [(ngModel)]="step.progress">
  
        <label>Checklist:</label>
        <ul>
          <li *ngFor="let item of step.checklist; let j = index">
            <label>Task:</label>
            <input type="text" [(ngModel)]="item.task">
  
            <label>Completed:</label>
            <input type="checkbox" [(ngModel)]="item.completed">
  
            <label>Date Completed:</label>
            <input type="date" [(ngModel)]="item.dateCompleted">
          </li>
        </ul>
      </div>
  
      <button (click)="updateRequisite()">Update</button>
      <button (click)="deleteRequisite()">Delete</button>
      <button (click)="deselectRequisite()">Back to List</button>
    </div>
  
    <!-- New Requisite Form -->
    <div *ngIf="!selectedRequirement && requisites.length === 0">
      <h3>New Requisite</h3>
      <form>
        <label for="item">Title:</label>
        <input type="text" [(ngModel)]="newRequisite.item">
  
        <label for="description">Description:</label>
        <input type="text" [(ngModel)]="newRequisite.description">
  
        <label for="step">Step:</label>
        <input type="text" [(ngModel)]="newRequisite.steps[0].step">
  
        <label>Checklist:</label>
        <ul>
          <li *ngFor="let item of newRequisite.steps[0].checklist; let j = index">
            <label>Task:</label>
            <input type="text" [(ngModel)]="item.task">
  
            <label>Completed:</label>
            <input type="checkbox" [(ngModel)]="item.completed">
  
            <label>Date Completed:</label>
            <input type="date" [(ngModel)]="item.dateCompleted">
          </li>
        </ul>
  
        <button (click)="addRequisite()">Add Requisite</button>
      </form>
    </div>
  </div>
  